import { Component, computed, inject, resource } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DokumentSearchParams } from '@features/dokumenter/dokument-search/dokument-search-params.model';
import { DokumentTypeApi } from '@features/dokumenter/dokument-type.api';
import { LetInputCprComponent } from '@shared/let-input-cpr/let-input-cpr.component';
import dayjs from 'dayjs';
import { Button } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePicker } from 'primeng/datepicker';
import { InputText } from 'primeng/inputtext';
import { Message } from 'primeng/message';
import { MultiSelect } from 'primeng/multiselect';
import { ScrollPanel } from 'primeng/scrollpanel';
import { Select } from 'primeng/select';
import { DokumentService } from '../dokument.service';

@Component({
  selector: 'app-dokument-search',
  imports: [
    ReactiveFormsModule,
    CheckboxModule,
    Button,
    InputText,
    Message,
    ScrollPanel,
    DatePicker,
    MultiSelect,
    Select,
    LetInputCprComponent,
  ],
  templateUrl: './dokument-search.component.html',
  styleUrl: './dokument-search.component.css',
})
export class DokumentSearchComponent {
  dokService = inject(DokumentService);
  dokumentTypeApi = inject(DokumentTypeApi);
  data = this.dokService.datasource.data;

  dokumentTyperResource = resource({
    loader: async ({ abortSignal }) => {
      return await this.dokumentTypeApi.getList(
        {
          sortBy: 'navn',
        },
        abortSignal
      );
    },
  });

  dokumentTyper = computed(() => {
    const typer = this.dokumentTyperResource.value()?.data || [];
    return typer.map(x => ({
      text: x.navn + ' ' + x.beskrivelse,
      value: x.id,
    }));
  });

  form = new FormGroup({
    startTidspunktDate: new FormControl(
      dayjs().subtract(2, 'year').startOf('year').toDate()
    ),
    slutTidspunktDate: new FormControl(dayjs().toDate()),
    cpr: new FormControl(),
    regnr: new FormControl(),
    dokumentId: new FormControl(),
    letsikringNr: new FormControl(),
    underskrevetDigitalt: new FormControl(),
    eEngagement: new FormControl(),
    dokumentAfsendelse: new FormControl(),
    dokumentTyper: new FormControl(),
  });

  afsendelseOptions = ['Sendt', 'IkkeSendt', 'Fejlet', 'Opgivet'];

  onClickSearch() {
    this.dokService.searchDokument({
      ...(this.form.value as DokumentSearchParams),
      dokumentTyper: this.form.value.dokumentTyper,
      fraDato: dayjs(this.form.value.startTidspunktDate).format('YYYY-MM-DD'),
      tilDato: dayjs(this.form.value.slutTidspunktDate).format('YYYY-MM-DD'),
    });
  }

  onClickReset() {
    this.form.reset();
    this.form.patchValue({
      startTidspunktDate: dayjs().subtract(1, 'year').toDate(),
      slutTidspunktDate: dayjs().toDate(),
    });
  }

  noHits = computed(() => {
    return (
      this.dokService.datasource.isLoaded() && this.data()?.totalRowCount == 0
    );
  });
}
